var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIengboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9718 11.3997C16.2033 11.2016 16.5566 11.1804 16.8087 11.3801C17.0922 11.6042 17.1393 12.0162 16.924 12.302L16.923 12.304L13.8683 16.1829C14.227 16.802 14.2058 17.6047 13.7384 18.2073L13.7375 18.2083C13.1243 18.9871 11.9897 19.1328 11.2033 18.5159C10.4239 17.9059 10.2777 16.7711 10.8947 15.9846L10.9894 15.8733C11.466 15.3589 12.1794 15.1752 12.8224 15.3723L15.881 11.4944L15.9718 11.3997Z",
    fill: "#054E5A",
    stroke: "#054E5A",
    strokeWidth: 0.178571
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9435 7.3186C19.7881 7.31871 20.4689 7.99595 20.4689 8.84106C20.4688 9.68917 19.7881 10.3663 18.9435 10.3665C18.0985 10.3665 17.4212 9.68898 17.4211 8.84106C17.4211 7.99614 18.0986 7.3186 18.9435 7.3186Z",
    fill: "#054E5A",
    stroke: "#054E5A",
    strokeWidth: 0.178571
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4885 4.33569C13.3334 4.33569 14.0148 5.0162 14.0149 5.86108C14.0149 6.70627 13.3332 7.38354 12.4885 7.38354C11.6439 7.3835 10.9631 6.70624 10.9631 5.86108C10.9632 5.01623 11.6436 4.33574 12.4885 4.33569Z",
    fill: "#054E5A",
    stroke: "#054E5A",
    strokeWidth: 0.178571
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1116 12.4141C21.9595 12.4142 22.637 13.0915 22.637 13.9365C22.6369 14.7845 21.9596 15.4618 21.1116 15.4619C20.2666 15.4619 19.5892 14.7844 19.5891 13.9365C19.5891 13.0916 20.2667 12.4141 21.1116 12.4141Z",
    fill: "#054E5A",
    stroke: "#054E5A",
    strokeWidth: 0.178571
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94696 7.35425C6.79498 7.35436 7.47231 8.0316 7.47235 8.87964C7.47235 9.72462 6.79488 10.402 5.94696 10.4021C5.10204 10.4021 4.4245 9.72456 4.4245 8.87964C4.42454 8.03167 5.10194 7.35425 5.94696 7.35425Z",
    fill: "#054E5A",
    stroke: "#054E5A",
    strokeWidth: 0.178571
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90085 12.3792C4.74551 12.3792 5.42722 13.0564 5.42722 13.9016C5.42711 14.7498 4.74557 15.427 3.90085 15.427C3.05617 15.427 2.37557 14.7498 2.37546 13.9016C2.37546 13.0565 3.05623 12.3792 3.90085 12.3792Z",
    fill: "#054E5A",
    stroke: "#054E5A",
    strokeWidth: 0.178571
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4981 2.59009C19.128 2.59009 24.5214 7.98294 24.5215 14.6096C24.5215 16.9171 23.8628 19.1434 22.6299 21.0901L22.629 21.092C22.4519 21.3541 22.1568 21.5178 21.8331 21.5178H3.16412C2.83999 21.5178 2.54804 21.3538 2.37115 21.092L2.37018 21.0901C1.13711 19.1593 0.478577 16.9168 0.478577 14.6096C0.478726 7.98305 5.87154 2.59024 12.4981 2.59009ZM12.4981 3.88306C6.63812 3.8832 1.87411 8.54112 1.87408 14.262C1.87408 16.2644 2.15729 18.2047 3.2442 19.8645L3.29498 19.9309C3.42274 20.0764 3.61188 20.1643 3.81451 20.1643L21.086 20.1477C21.3203 20.1476 21.5308 20.0333 21.6592 19.845C22.7444 18.17 23.126 16.26 23.126 14.262C23.126 8.54106 18.3583 3.88306 12.4981 3.88306Z",
    fill: "#054E5A",
    stroke: "#054E5A",
    strokeWidth: 0.178571
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIengboard);
export default __webpack_public_path__ + "static/media/iengboard.a783f71de0bbb5e5df4681bc53092d47.svg";
export { ForwardRef as ReactComponent };